import Pagination from "@/components/ui/Pagination";
import VideoSection from "./VideoSection";
import { VideoData } from "@/redux/feature/videoDashboard/videoDashboardType";
import { Dispatch, ReactNode, SetStateAction } from "react";

interface VideoSectionWrapperProps {
  title: string;
  icon: ReactNode;
  videos: VideoData[];
  isLoading: boolean;
  pagination?: {
    currentPage: number;
    totalPages: number;
    setPage: Dispatch<SetStateAction<number>>;
  };
  currentlyPlaying: string | null;
  setCurrentlyPlaying: Dispatch<SetStateAction<string | null>>;
  setIsDetailsModalOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedVideo?: Dispatch<SetStateAction<VideoData | null>>;
  isProcessing: boolean;
}

const VideoSectionWrapper = ({
  title,
  icon,
  videos,
  isLoading,
  pagination,
  currentlyPlaying,
  setCurrentlyPlaying,
  setIsDetailsModalOpen,
  setSelectedVideo,
  isProcessing,
}: VideoSectionWrapperProps) => {
  return (
    <div className="mb-6">
      <VideoSection
        title={title}
        icon={icon}
        videos={videos}
        isLoading={isLoading}
        currentlyPlaying={currentlyPlaying}
        setCurrentlyPlaying={setCurrentlyPlaying}
        setIsDetailsModalOpen={setIsDetailsModalOpen}
        setSelectedVideo={setSelectedVideo}
        isProcessing={isProcessing || false}
      />

      {pagination && pagination.totalPages > 1 && (
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          setPage={pagination.setPage}
        />
      )}
    </div>
  );
};

export default VideoSectionWrapper;
